<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Manage Users" class="card-container"></Header>
      <div v-if="duringSubmit" class="loading">
        <Loading />
      </div>
      <div  style="margin-left:18px;" class="col-md-12">

        <base-button v-if="isLoggedIn && (isSuperAdmin || isPNManager)" @click="inviteModal()"
          class="btn-dark float-sm-none float-md-left pad">Invite Partner Nation</base-button>

        <!-- <base-button v-if="isLoggedIn && isSponsor" -->

      </div>


      <invite-partner-nation-email-modal :show-line-item-modal="showLineItemModal" v-on:modal-closed="clearModalData">
        <template v-slot:modal-link> Add </template>
      </invite-partner-nation-email-modal>
      <div style="margin-left:3px;" class="col-md-12">
        <div class="row">
          <export-group v-bind:isLoading="duringSubmit" v-on:loading="toggleLoading" :name="'Users'"
             :excelExportCustom="exportToExcel"  :isUsingCustomExcel="true" :getData="getExportData"></export-group>

          <div class="col-md-4 offset-md-8">
            <div class="row flex-row-reverse">
              <div class="col-md-8">
                <label for="searchBox">Search:</label>
                <el-input id="searchBox" type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                  @input="search()" v-model="searchText" placeholder="Search all Users..."
                  v-b-popover.hover.top="'Search results appear immediately upon typing.'"></el-input>
                <a style="color: #0e8142;cursor: pointer" @click="redirectSearch()">Advanced Search</a>
              </div>
              <div v-if="this.isSponsor" class="col-md-4">
                <label for="searchBox">All Users/My Users</label>
                <div>
                  <el-switch v-model="getUserToggle" v-on:change="toggleUserType()" active-color="#275d34"
                    inactive-color="grey">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-left: 20px !important; margin-right: 20px !important; " class="row">
        <el-table :data="paginatedUsers.results" :key="tableKey"
          :default-sort="{ prop: 'approvalStatusName', order: 'descending' }">
          <el-table-column :min-width="110" align="left" label="Actions" sortable>
            <div slot-scope="scope">
              <span class="hide-if-medium-screensize"></span>
              <router-link :to="'/admin/profile/' + scope.row.id" class="btn-link btn-primary">
                <i v-if="!isOUSD" class="tim-icons icon-pencil"></i>
                <span v-if="!isOUSD" class="hide-if-small-screensize">Edit</span>
                <span v-else class="hide-if-small-screensize">View</span>

              </router-link>
              <lock-button v-if="scope.row.approvalStatusName === 'APPROVED'"
                v-on:reloadUnlockLockInfo="reloadUnlockLockInfo(scope.row.id)"
                 :isUserPage="true" :id="scope.row.id"
                :userName="scope.row.firstName + ' ' + scope.row.lastName"></lock-button>
            </div>
          </el-table-column>

          <el-table-column sortable v-for="(column) in tableColumns" :key="column.label" :min-width="column.minWidth"
            :prop="column.prop" :label="column.label"></el-table-column>
          <el-table-column prop="approvalStatusName" sortable :min-width="150" align="left" label="Approval Status">
            <div slot-scope="scope">

              <el-tooltip v-if="scope.row.approvalStatusName === 'APPROVED'" effect="dark" placement="top-start"
                :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.approvalDate)">
                <p>{{ scope.row.approvalStatusName }}</p>
              </el-tooltip>
              <el-tooltip v-if="scope.row.approvalStatusName === 'PENDING'" effect="dark" placement="top-start"
                :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.createDate)">
                <p>{{ scope.row.approvalStatusName }}</p>
              </el-tooltip>
              <el-tooltip v-if="scope.row.approvalStatusName === 'REJECTED'" effect="dark" placement="top-start"
                :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.createDate)">
                <p>{{ scope.row.approvalStatusName }}</p>
              </el-tooltip>
              <el-tooltip v-if="scope.row.approvalStatusName === 'LOCKED'" effect="dark" placement="top-start"
                :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.createDate)">
                <p>{{ scope.row.approvalStatusName }}</p>
              </el-tooltip>

            </div>
          </el-table-column>

          <el-table-column sortable prop="expirationDate" :min-width="140" align="left" label="Expiration Date">
            <div v-if="parseInt(dateDifference(scope.row.expirationDate))"
              :style="{ height: '70px', alignContent: 'center', textAlign: 'center', width: '100%', backgroundColor: backgroundColor(scope.row.expirationDate, !['PENDING', 'REJECTED' ].includes(scope.row.approvalStatusName)) }"
              slot-scope="scope">
              <span class="hide-if-medium-screensize"></span>
              {{ dayjs(scope.row.expirationDate).format('MM/DD/YYYY') }}
            </div>

          </el-table-column>
        </el-table>
      </div>

      <div class="row justify-content-end">
        <label for="ResultsPerPageDropdown" class="results-per-page">Results Per Page:</label>
        <el-select id="ResultsPerPageDropdown" v-model="pageCount" @change="getPaginateUsers()" name="PageOptions"
          class="select-primary">
          <el-option v-for="(item, index) in pageCountOptions" :value="item" class="select-primary"
            :key="index"></el-option>
        </el-select>

        <base-pagination v-model="paginatedUsers.currentPage" @input="getPaginateUsers()"
          :perPage="paginatedUsers.pageSize" :pageCount="paginatedUsers.pageCount">
        </base-pagination>
      </div>
    </div>
  </center>
</template>

<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option, Switch } from "element-ui";
import LockButton from "@/components/App/account/LockButton.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import InvitePartnerNationEmailModal from "@/components/admin/InvitePartnerNationEmailModal.vue";
import { BaseButton, Modal, ImageUpload, BasePagination, BaseSwitch, ExportGroup } from "@/components";
import Header from "@/components/App/Header.vue";
import Util from "@/util/util";
import Loading from 'src/components/LoadingPanel';
import dayjs from 'dayjs';
import moment from 'moment';

// import swal from "sweetalert2";

export default {
  name: "admin-users-dashboard",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BasePagination,
    BaseButton,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    Treeselect,
    ImageUpload,
    Header,
    LockButton,
    InvitePartnerNationEmailModal,
    ExportGroup,
    Loading
  },
  data() {
    return {
      duringSubmit: false,
      showLineItemModal: false,
      map: {
        "FirstName": "firstName",
        "MiddleName": "middleName",
        "LastName": "lastName",
        "Title": "title",
        "PhoneNumber": "phoneNumber",
        "Organization": "organizationName",
        "Email": "email",
        "ApprovedBy": "approverName",
        "Roles": "roleString",
        "ApprovalStatus": "approvalStatusName",
        "SponsorName": "sponsorName",
        "ExpirationDate": "expirationDate"
      },
      images: {
        regular: null,
      },
      tableColumns: [
        {
          prop: "email",
          label: "User Email",
          minWidth: 140,
        },
        {
          prop: "sponsorName",
          label: "Sponsor",
          minWidth: 140,
        },
        {
          prop: "firstName",
          label: "First Name",
          minWidth: 135,
        },
        {
          prop: "lastName",
          label: "Last Name",
          minWidth: 135,
        },
        {
          prop: "roleString",
          label: "Roles",
          minWidth: 160,
        },
        {
          prop: "organizationName",
          label: "Organization",
          minWidth: 145,
        },

      ],
      searchTimeOut: null,
      pageCount: 5,
      tableKey: 0,
      searchText: "",
      pageCountOptions: [],
      openSearchModal: false,
      isNew: true,
      deleteDisabled: false,
      currentUser: null,
      roles: [],
    };
  },
  
  async mounted(){
    await this.getUser();
  },
  async created() {
    this.pageCountOptions = Util.getInitialPaginationInfo().perPageOptions;
    this.$loaderApp.addRequest();
    await this.getAllUsersPaginate({
      pageNumber: this.paginatedUsers.currentPage
        ? this.paginatedUsers.currentPage
        : 1,
      pageCount: this.paginatedUsers.pageSize
        ? this.paginatedUsers.pageSize
        : this.pageCount,
      searchText: this.searchText ? this.searchText : "",
      sponsorId: this.getUserToggle
    });
    this.$loaderApp.completeRequest();

  },
  watch: {
    pageCount(newValue, oldValue) {
      if (newValue != oldValue) {
this.paginatedUsers.currentPage = 1;
         if (this.getUserToggle) {
        this.getUserBySponsor(this.getUserToggle);
      } else {
        this.getPaginateUsers();
      }
}
    },
  },
  computed: {
    ...mapGetters({
      users: "users/allUsers",
      user: "users/user",
      paginatedUsers: "users/paginatedUsers",
      allUsersForExporting: "users/allUsersForExporting",
      isSponsor: "authentication/isSponsor",
      isPNManager: "authentication/isPNManager",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      approvalStatuses: "approvalStatus/approvalStatuses",
      isOUSD: "authentication/isOUSD",
      isLoggedIn: "authentication/isLoggedIn",
      isSuperAdmin: "authentication/isSuperAdmin",
      getUserToggle: "users/getUserToggle",

    }),
    selectedPageCount() {
      return this.pageCount;
    },
    allTableData() {
      return this.allUsersForExporting;
    },
    userId() {
      return this.user.id;
    },
    isApproved() {
      return this.user.approvalStatusName == "APPROVED" ? true : false;
    },
    backgroundColor: function () {
      var vm = this;
      return function (date, isActive = true) {
        if(!isActive) return 'transparent'

        var difference = vm.dateDifference(date);

        if (difference <= 60) return 'rgb(255, 206, 206)';

        else if (difference <= 90) return 'rgb(240,209,78)';

        else return 'transparent';
      };
    }
  },
  methods: {
    ...mapActions({
      getAllUsersPaginate: "users/getAllUsersPaginate",
      getAllUsersForExporting: "users/getAllUsersForExporting",
      saveUser: "adminUsers/saveUser",
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getStatuses: "approvalStatus/getApprovalStatuses",
      exportUsersToExcel: "users/exportUsersToExcel",
      setUserToggle: "users/setUserToggle",
      loadUserUnLockSponsor: "users/loadUserUnLockSponsor",
      loadUserLockSponsor: "users/loadUserLockSponsor",
    }),
    dayjs,
    localtimeZone(date) {
      return Util.formatDateWithLocalTimezone(date);
    },
    async toggleLoading(action) {
      this.duringSubmit = action;
      if (this.duringSubmit)
        this.$loaderApp.addRequest();
      else
        this.$loaderApp.completeRequest();
    },
    async toggleUserType() {
      await this.setUserToggle(!this.getUserToggle);
      if (this.getUserToggle) {
        this.getUserBySponsor(this.getUserToggle);
      } else {
        this.getPaginateUsers();
      }
      // flip the toggle value
    },

    inviteModal() {
      this.showLineItemModal = true;
    },
    clearModalData() {
      this.showLineItemModal = false;
    },
    async getPaginateUsers() {
      var paginationInfo = {
        pageNumber: this.paginatedUsers.currentPage
          ? this.paginatedUsers.currentPage
          : 1,
        pageCount: this.pageCount,
        searchText: this.searchText ? this.searchText : "",
        sponsorId: this.getUserToggle
      };
      this.duringSubmit = true;
      this.$loaderApp.addRequest();
      await this.getAllUsersPaginate(paginationInfo);
      this.duringSubmit = false;
      this.$loaderApp.completeRequest();
    },
    async getUser() {
      let ctx = this;
      var response = await axios.get(`api/applicationusers/email`);
      ctx.roles = response.data.roles;
    },
    async getUserBySponsor(id) {
      this.paginatedUsers.currentPage = 1;
      var paginationInfo = {
        pageNumber: this.paginatedUsers.currentPage
          ? this.paginatedUsers.currentPage
          : 1,
        pageCount: this.pageCount,
        searchText: this.searchText ? this.searchText : "",
        sponsorId: id
      };
      this.duringSubmit = true;
      this.$loaderApp.addRequest();
      await this.getAllUsersPaginate(paginationInfo);
      this.duringSubmit = false;
      this.$loaderApp.completeRequest();
    },
    search() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.paginatedUsers.currentPage = 1;
        self.getPaginateUsers();
      }, 1000);
    },
    async getExportData() {
      await this.getAllUsersForExporting(
        { searchText: this.searchText, sponsorId: this.getUserToggle }
      );

      return Util.mapTheData(this.allTableData, this.map)
    },
    async exportToExcel() {
           // this.$emit("loading", true);
            try {
              let sponsorId = (!this.getUserToggle) ? "" : `${this.getUserToggle}`;

                let res = await axios({
                    url: "api/export/users/excel",
                    method: "POST",
                    data: { searchText: this.searchText, sponsorId },
                    responseType: "blob",
                    config: { showToast: false },
                });

                Util.fileDownload(res.data, "users.xlsx");
                //this.$emit("loading", false);
            } catch (err) {
                this.$toast.error(
                    "Error on exporting to the excel, Please try again later"
                );
                //this.$emit("loading", false);
            }
        },
    dateDifference(date) {
      const today = dayjs(new Date());
      const expiry = dayjs(date);
      if (expiry != 'Invalid Date' && today) {
        const days = expiry.diff(today, 'days');
        if (days) {
          return days
        }
        else {
          return ""
        }
      }

    },
    onImageChange(file) {
      this.images.regular = file;
    },

    cancelAdminUserModalClicked() {
      this.$refs.AdminUserModal.hide();
    },

    openAdvancedSearch() {
      this.$refs.testd.show();
    },

    redirectSearch() {
      this.$router.push("/Admin/users/AdvancedSearch");
    },
    async reloadUnlockLockInfo(id) {
      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.paginatedUsers.currentPage = 1;
        self.getPaginateUsers();
      }, 1000);
    },
  },
};
</script>

<style scoped>
a:hover {
  cursor: pointer
}

.pad {
  padding-left: 2%;
  padding-right: 2%;

}

p {
  color: rgba(34, 42, 66, 0.7) !important;
}

.greenClass {
  background: green;
}

.redClass {
  background: red;
}
</style>
